
import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import '../../scss/Navmenudetail.scss'

export default function TimeChuanBi(props) {
    const { visible, startNow } = props;
    const [count, setCount] = useState(60);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        if (visible) {
            const interval = setInterval(() => {
                setCount((data) => {
                    let newCount = data - 1;
                    if (newCount == 0) {
                        startNow();
                    }
                    return newCount;
                })
            }, 1000);
            return () => {
                clearInterval(interval);
            };
        }
    }, [visible]);

    const onClickFinish = () => {
        startNow();
    }

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="card">
            <Dialog
                visible={visible} position='top-right'
                closable={false}
                modal={false}
                style={{
                    width: isMobile ? '80vw' : '20vw',
                    height: '90vh'
                }}
                onHide={() => { }}
                draggable={false} resizable={false}>
                <div style={{ height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ textAlign: 'center' }}>
                        <span style={{ fontSize: '24px', fontWeight: '700' }}>Preparation Time</span>
                    </div>
                    <div className="displayedTime" style={{ textAlign: 'center', minHeight: '70%' }}>
                        <div style={{

                            color: 'black',
                            fontWeight: '700',
                            fontSize: '40px',
                            width: '200px',
                            height: '200px',
                            backgroundColor: '#fff',
                            boxShadow: '0 0 26px #1507b729',
                            borderRadius: '50%',
                            margin: '0 auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '20px',
                        }}>
                            {count}s
                        </div>

                    </div>
                    {/* <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 'auto'
                        }}
                    >
                        <Button
                            onClick={() => onClickFinish()}
                            className="btn2 "
                            style={{ width: '90%', display: 'flex', justifyContent: 'center' }}
                        >
                            Start Now
                        </Button>
                    </div> */}

                </div>
            </Dialog>
        </div>
    )
}
